import api, { http } from "../service";
import Cookies from "js-cookie";
import axios from "axios";

import { JSEncrypt } from "jsencrypt";

const { origin } = window.location;
const testEnvReg = /test\.ximalaya\.com/;
const uatEnvReg = /uat\.ximalaya\.com/;
const u = navigator.userAgent;
const isUat = uatEnvReg.test(origin);
export const isTest = testEnvReg.test(origin);
export const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

export const ENV = isTest ? "test" : isUat ? "uat" : "production";
export const TOKEN = isTest ? "4&_token" : isUat ? "6&_token" : "1&_token";

export const STATIC_SRC = isTest
  ? "https://static2.test.ximalaya.com"
  :isUat
  ?"https://s1.uat.xmcdn.com"
  : "https://s1.xmcdn.com";

export const IS_IN_APP = /iting/.test(navigator.userAgent.toLowerCase());

export const API_TOKEN_HOST = isTest
  ? "https://test.ximalaya.com"
  : isUat
  ? "https://www.uat.ximalaya.com"
  : "https://www.ximalaya.com";
export const API_HOST = isTest
  ? "https://m.test.ximalaya.com"
  : isUat
  ? "https://m.uat.ximalaya.com"
  : "https://m.ximalaya.com";
// export const API_HOST_HTTP = isTest
//   ? "http://m.test.ximalaya.com"
//   : "http://m.ximalaya.com";

//加密
function encryptStr(val) {
  var publickey =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVhaR3Or7suUlwHUl2Ly36uVmboZ3+HhovogDjLgRE" +
    "9CbaUokS2eqGaVFfbxAUxFThNDuXq/fBD+SdUgppmcZrIw4HMMP4AtE2qJJQH/KxPWmbXH7Lv+9CisNt" +
    "PYOlvWJ/GHRqf9x3TBKjjeJ2CjuVxlPBDX63+Ecil2JR9klVawIDAQAB";
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(publickey);
  return encrypt.encrypt(val);
}
//发验证码
export function sendVerifyCode(phoneCode, pic_id, pic_code) {
  return new Promise(async (resolve, reject) => {
    try {
      const curTime = new Date().getTime();
      //获取token
      const { token } = await http.get(
        API_TOKEN_HOST + api.GETTOKEN + "/" + curTime
      );

      //加密参数
      const code = encryptStr(`m_phone=${phoneCode}&nonce=${token}`);
      const param = {
        code
      };
      //发送验证码过多，需要图形验证码
      if (pic_id && pic_code) {
        param.checkCode = pic_code;
        param.checkUUID = pic_id;
      }

      axios({
        url: API_HOST + api.SENDERIFYCODE,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Accept: "application/json, text/javascript, */*; q=0.01"
        },
        withCredentials: true,
        method: "post",
        data: {
          ...param
        },
        transformRequest: [
          function(data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      }).then(res => {
        resolve(res.data);
      });
      // //发验证码 const res = await http.post(API_HOST + api.SENDERIFYCODE, {   params:
      // {     ...param   },   headers: {     "Content-Type":
      // "application/x-www-form-urlencoded;charset=UTF-8"   } })
    } catch (err) {
      reject(err);
    }
  });
}
//通过验证码注册喜马拉雅账户
export function registerAccountByVerifyCode(phoneCode, smsCode) {
  return new Promise(async (resolve, reject) => {
    try {
      // 获取token const randomToken = await http   .get(API_TOKEN_HOST + api.GETTOKEN)
      // .token;
      const curTime = new Date().getTime();
      http.get(API_TOKEN_HOST + api.GETTOKEN + "/" + curTime).then(res => {
        const randomToken = res.token;
        //加密参数
        const code = encryptStr(
          `m_phone=${phoneCode}&nonce=${randomToken}&smsCode=${smsCode}`
        );
        console.log(randomToken, code);
        //注册
        axios({
          url: API_HOST + api.CREATEACCOUNT,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            Accept: "application/json, text/javascript, */*; q=0.01"
          },
          withCredentials: true,
          method: "post",
          data: {
            code
          },
          transformRequest: [
            function(data) {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            }
          ]
        }).then(res => {
          if (res.data.ret === 0) {
            // const { uid, token } = res.data;
            // Cookies.set(TOKEN, `${uid}&${token}`, {
            //   domain: ".ximalaya.com",
            //   path: "/"
            // });
          }
          resolve(res.data);
        });
      });
    } catch (err) {
      reject(err);
    }
  });
}
//验证手机号码
export function verifyPhoneNumber(phone) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phone);
}

// app类型
export function getAppType() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) === "micromessenger") {
    return "weixin";
  } else if (ua.match(/QQ/i) === "qq") {
    return "QQ";
  } else if (ua.match(/Alipay/i) === "alipay") {
    return "alipay";
  } else if (ua.match(/iting/i) === "iting") {
    return "xmly";
  }
  return false;
}

// 获取随机整数
export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}



// WEBPACK FOOTER //
// ./src/utils/index.js